import {
  PaymentPreviewErrorPayload,
  PaymentPreviewHostedPaymentV1Response,
  SerializableMap,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsReviewPaymentComponentPaymentActions =
  createActionGroup({
    source: 'Hosted Payments Review Payment Component - Payment',
    events: {
      'Execute Payment Complete': props<{
        transactionResults: SerializableMap<TransactionAuthorizationResult>;
        paymentComplete: boolean;
      }>(),
      'Check Payment Status Completed': props<{
        results: SerializableMap<TransactionAuthorizationResult>;
        checkStatusCount: number;
        checkStatusTimeout: boolean;
        authorizationPending: boolean;
        paymentComplete: boolean;
      }>(),
      'Check Payment Status Timed Out': props<{
        results: SerializableMap<TransactionAuthorizationResult>;
      }>(),
      'Check Payment Status Error': emptyProps(),
      'Update Payment Preview Payment Reference Success': props<{
        response: PaymentPreviewHostedPaymentV1Response;
      }>(),
      'Update Payment Preview Payment Reference Failed': props<{
        error: PaymentPreviewErrorPayload;
      }>(),
    },
  });
